/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  initialDataLoading: true,
  isFetching: false,
  isSending: false,
  noCadence: false,
  cadence: { id: null },
  cadences: [],
  burndownData: null,
  nextCadence: null
};

const cadenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.REQUEST_CADENCE:
      return { ...state, isSending: true, isFetching: true };
    case Types.REQUEST_CADENCE_FAILED:
      return { ...state, isSending: false, isFetching: false };
    case Types.RECEIVE_CADENCES:
      // find current cadence for team (set by controller) in action.cadences and set/clear it as state.cadence
      // eslint-disable-next-line no-case-declarations
      const current = action.cadences.find((cad) => cad.current);
      return {
        ...state,
        initialDataLoading: false,
        isFetching: false,
        cadences: action.cadences,
        cadence: current
      };
    case Types.SET_CADENCE:
      return {
        ...state,
        isFetching: false,
        noCadence: !action.cadence,
        cadence: action.cadence
      };
    case Types.SET_NEXT_CADENCE:
      return {
        ...state,
        nextCadence: action.nextCadence,
        cadence: action.nextCadence
      };
    case Types.CLEAR_NEXT_CADENCE:
      return { ...state, nextCadence: null };
    case Types.UPDATE_CADENCE: {
      const currentCadence = state.cadences.find(
        (cadence) => cadence.id === action.cadence.id
      );
      let cadences = [];
      if (currentCadence) {
        cadences = state.cadences.map((cadence) => {
          if (cadence.id === action.cadence.id) {
            return action.cadence;
          }
          return cadence;
        });
      } else {
        cadences = state.cadences.slice(0);
        cadences.push(action.cadence);
      }

      if (!state.cadence || state.cadence.id === action.cadence.id) {
        return {
          ...state,
          isFetching: false,
          cadence: { ...action.cadence },
          cadences
        };
      }
      return { ...state, isFetching: false, cadences };
    }
    case Types.DELETE_CADENCE: {
      const cadences = state.cadences.filter(
        (cadence) => cadence.id !== action.cadence.id
      );
      return { ...state, isFetching: false, cadences };
    }
    case Types.GET_CADENCE_BURNDOWN_DATA:
      return {
        ...state,
        isFetching: false,
        noCadence: false,
        burndownData:
          state.cadence?.id === action.cadenceId
            ? action.burndownData
            : state.burndownData
      };
    case Types.SEND_CADENCE:
      const cadence = state.cadence ? state.cadence : action.cadence;
      if (action.cadence && action.cadence.status)
        cadence.status = action.cadence.status;
      return { ...state, cadence, isSending: true };
    case Types.NO_CADENCE:
      return { ...state, isFetching: false, noCadence: true, cadence: null };
    case Types.CADENCES_INITIAL_STATE:
      return { ...state, initialDataLoading: true };
    case Types.CLEAR_ACTIVE_SPINNER:
      return {
        ...state,
        isFetching: false,
        isSending: false,
        initialDataLoading: false
      };
    default:
      return state;
  }
};

export default cadenceReducer;
